import axios from "axios";
import { getChestApiUrl } from "../../helpers";

const getConfiguration = (session)=> axios.get(`${getChestApiUrl()}/chestApi/data/configuration?session=${session}`,{})

export default {getConfiguration}